import { Box, Grid, makeStyles, Typography } from "@material-ui/core";
import { ReactComponent as Hut } from "../../assets/images/icons/hut.svg";
import { ReactComponent as DashedEllipse } from "../../assets/images/icons/dashed_ellipse.svg";
import { ReactComponent as TenantOn } from "../../assets/images/icons/tenant_on.svg";
import { ReactComponent as TenantOff } from "../../assets/images/icons/tenant_off.svg";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2.5),
    textAlign: "center",
  },
  relativeBox: {
    position: "relative",
  },
  absoluteImage: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));
export const EmptyPage = ({ headerText = "units", footerText = "Unit" }) => {
  const classes = useStyles();
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      className={classes.root}
      spacing={3}
    >
      <Grid item xs={12}>
        <Typography variant="h2">No {headerText} added yet</Typography>
      </Grid>
      <Grid item xs={12}>
        <Box className={classes.relativeBox}>
          <DashedEllipse />
          {headerText == "units" ? (
            <Hut className={classes.absoluteImage} />
          ) : (
            <Box className={classes.absoluteImage}>
              <TenantOn style={{ paddingRight: "5px" }} />
              <TenantOff />
            </Box>
          )}
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h4">Fill in the blanks and unlock all the insights!</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography>{footerText} data is still missing</Typography>
      </Grid>
    </Grid>
  );
};
